import { Check } from "lucide-react";

const shortLabels = ["Service", "Team", "Areas", "Pricing", "Review"];

export default function SetupStepper({ groups, activeIndex, completed, disabled, onSelect }) {
  return <nav aria-label="Setup progress" className="py-2">
    <ol className="flex items-start">
      {groups.map((group, index) => {
        const current = index === activeIndex;
        const done = completed[index];
        return <li key={group.label} className="relative min-w-0 flex-1">
          {index < groups.length - 1 && <span aria-hidden="true" className={`absolute left-1/2 top-[18px] h-px w-full ${done ? "bg-emerald-400" : "bg-slate-200"}`} />}
          <button type="button" aria-label={`${index + 1}. ${group.label}`} aria-current={current ? "step" : undefined} disabled={disabled} onClick={() => onSelect(index)} className="relative flex w-full min-w-0 flex-col items-center gap-2 rounded-lg px-1 py-1 text-center outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 disabled:cursor-not-allowed disabled:opacity-50">
            <span aria-hidden="true" className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-xs font-semibold transition ${current ? "border-emerald-600 bg-emerald-600 text-white ring-4 ring-emerald-50" : done ? "border-emerald-300 bg-white text-emerald-700" : "border-slate-300 bg-white text-slate-400"}`}>
              {done && !current ? <Check size={14} /> : index + 1}
            </span>
            <span className={`min-w-0 text-xs leading-tight ${current ? "font-semibold text-emerald-700" : done ? "font-medium text-slate-700" : "text-slate-500"}`}><span className="sm:hidden">{shortLabels[index] || group.label}</span><span className="hidden sm:inline">{group.label}</span></span>
          </button>
        </li>;
      })}
    </ol>
  </nav>;
}
